import React from 'react';
import { CellProps } from 'react-table';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { IDistrict } from 'src/types/district';

const DistrictActionsColumn: React.FunctionComponent<CellProps<IDistrict>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IDistrict>) => {
    return (
        <div>
            <Link to={Router.generate(routes.DISTRICT_DETAIL, { id: original.id })}>{original.name}</Link>
        </div>
    );
};

export default DistrictActionsColumn;
